import classnames from 'classnames/bind'
import React from 'react'

import Image from '~/components/Image'
import RichText from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import ImageWithPlaceHolder from '../ImageWithPlaceholder'
import css from './styles.module.scss'
import { LogoListProps } from './types'

const cx = classnames.bind(css)

function LogoList({ className, title, items }: LogoListProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-content' })

  return (
    <div className={cx(css.LogoList, className)}>
      <div className={gridStyle}>
        {title && (
          <RichText className={cx(css.title, titleStyle)} render={title} />
        )}
        {items?.length > 0 && (
          <div className={css.logoWrapper}>
            {items.map((item, index) => {
              return (
                <div className={css.logo} key={index}>
                  <ImageWithPlaceHolder
                    className={css.logoImage}
                    layout="fill"
                    objectFit="contain"
                    {...item.image}
                  />
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

LogoList.defaultProps = {}

export default LogoList
